'use strict';

angular.module('imagetrend.components')
    .controller('SupplementTrainingModalController', ['$scope', '$modalInstance', 'training', 'Topics', 'TrainingLocations', '$timeout', 'Upload', 'FileTypes', '$filter', function ($scope, $modalInstance, training, Topics, TrainingLocations, $timeout, Upload, FileTypes, $filter) {
        if (training.training_topics == null) {
            training.training_topics = [];
        }
        $scope.training = training;
        $scope.uploading = false;
        $scope.working = false;
        $scope.locationsLoading = true;

        FileTypes.getByEnterprise().then(function (data) {
            if (data != null && data.length > 0) {
                $scope.extensions = data.toString();
            } else {
                $scope.extensions = "'*'";
            }

        });

        Topics.get({ supplementalOnly: true }).then(function (topics) {
            $scope.topics = topics;
        })

        TrainingLocations.get().then(function (locations) {
            if (locations != null) {
                if ($scope.training.training_location_id != null) {
                    var location = $filter('filter')(locations, $scope.training.training_location_id);
                    if (location != null && location.length > 0) {
                        $scope.training.training_location = location[0];
                    }
                }
                else if ($scope.training.location != null) {
                    var l = { id: $scope.training.location, name: $scope.training.location }
                    locations.push(l);
                    $scope.training.training_location = l;
                }
                $scope.locations = locations;
            }
            $scope.locationsLoading = false;
        })

        $scope.optionChange = function (training, viewValue) {
            training.training_location = null;
            training.training_location_id = null;
            training.training_location_name = viewValue;
            training.location = viewValue;
        }

        $scope.locationChange = function (training) {
            if (training.training_location != null) {
                training.training_location_name = training.training_location.name;
                training.location = training.training_location.name;
                if (isValidGuid(training.training_location.id)) {
                    training.training_location_id = training.training_location.id;                    
                }
                else {
                    training.training_location = null;
                    training.training_location_id = null;
                }
            }
        }

        $scope.remove = function (array, item) {
            array.splice(array.indexOf(item), 1);
        }

        $scope.topicChange = function (topic, topics) {
            topic.changing = true;
            topics.forEach(function (t) {
                if (topic.topic_id == t.id) {
                    topic.topic_name = t.name;
                    topic.availableoptions = t.options;
                    topic.options = null;
                    $timeout(function () {
                        topic.changing = false;
                    }, 10)                    
                }
            })
        }

        $scope.fileChange = function () {
            if (!$scope.working) {
                $scope.uploading = false;
            }
        }

        $scope.fileUpdated = function (file) {
            if (file != null) {
                $scope.working = true;
                Upload.base64DataUrl(file).then(function (content) {
                    $scope.training.file_content = content;
                    $scope.training.file_name = file.name;
                    $scope.training.file_updated = true;
                    $scope.working = false;
                    $scope.uploading = false;
                })
            }
            else {
                $scope.uploading = false;
            }
        }

        $scope.filePicked = function () {
            $scope.uploading = true;
        }

        $scope.save = function () {
            $modalInstance.close($scope.training);
        }

        $scope.close = function () {
            $modalInstance.dismiss('cancel');
        }

        $scope.hasOptions = function (training) {
            var any = false;

            training.training_topics.forEach(function (topic) {
                if (topic.availableoptions != null) {
                    any = true;
                }
            })

            return any;
        }
    }])
;